import store from '@/store.js'
import permissions from '@/util/permissions.js';
import messages from "@/languages"
import domain from '@/util/domain'
let language = "en"

const company = [{
  path: 'about',
  name: messages[language].about,
  meta: {
    show: true
  },
  query: {
    action: 'post',
    params: 'main/about'
  }
},
{
  path: 'carres',
  name: messages[language].carres,
  meta: {
    show: permissions().carres
  },
  query: {
    email: store.state.operators.contact_email
  }
},
{
  path: 'contact',
  name: messages[language].contact,
  meta: {
    show: permissions().contact
  },
  query: {
    email: store.state.operators.contact_email
  }
},
{
  path: 'askedQuestions',
  name: messages[language].frequentlyAskedQuestions,
  meta: {
    show: domain() === 'goldebet'
  },
  blankUrl: 'https://goldebet.info/'
},
]

const downloads = [{
  path: 'appClient',
  name: 'appClient',
  meta: {
    show: store.state.operators.credit != 0  ? true : false
  },
  query: {
    download: 'true',
    url: 'https://dozr8la71aog.cloudfront.net/domains'
  }
},
{
  path: 'appAgent',
  name: 'appAgent',
  meta: {
    show: permissions().downloadsAppAgent
  },
  query: {
    download: 'true',
    url: 'https://dozr8la71aog.cloudfront.net/apk'
  }
},
{
  path: 'blog',
  name: 'blog',
  meta: {
    show: domain() === 'betinterativovip'
  },
  blankUrl: 'https://bloginterativo.com/'
},
{
  path: 'affiliates',
  name: 'affiliates',
  meta: {
    show: domain() === 'betinterativovip'
  },
  blankUrl: 'https://afiliadointerativo.com/'
},
]

const rules = [{
  path: 'help',
  name: messages[language].help,
  meta: {
    show: true
  },
  query: {
    component: 'rules',
  }
},
{
  path: 'regulation',
  name: messages[language].regulation,
  meta: {
    show: store.state.operators.credit == '1' || store.state.operators.credit == '0',
  },
  query: {
    action: 'post',
    params: 'main/regulation'
  }
},
// POLÍTICA DE PRIVACIDADE
{
  path: 'privacy',
  name: 'privacy',
  meta: {
    show: permissions().privacy
  },
  query: {
    action: 'post',
    params: 'Main/getDocumentDataProtection'
  }
},
// AML 
{
  path: 'amlPolicy',
  name: messages[language].amlPolicy,
  meta: {
    show: permissions().amlPolicy
  },
  query: {
    action: 'post',
    params: 'Main/getDocumentAML'
  }
},
]

const responsibleGaming = [

  // JOGO RESPONSÁVEL
  {
    path: "responsibleGaming",
    name: "DocumentGamingResponsible",
    meta: {
      show: store.state.operators.credit == 2 ? true : false,
    },
    query: {
      component: 'responsibleGaming',
    },
    component: () => import("@/views/pages/router-view"),
    children: [{
      path: "responsibleGamingDoc",
      name: "responsibleGamingDoc",
      meta: {
        show: false,
      },
      // operator: true,
      component: () => import("@/views/pages/responsibleGaming/document"),
    },
    {
      path: "autoExclude",
      name: 'autoExclude',
      meta: {
        show: false,
      },
      // operator: true,
      component: () => import("@/views/pages/responsibleGaming/autoExclude"),
    },
    {
      path: "accountSuspend",
      name: 'accountSuspend',
      meta: {
        show: false,
      },
      // operator: true,
      component: () => import("@/views/pages/responsibleGaming/accountSuspend"),
    },
    ],
  },

  // TERMOS DE USO
  {
    path: 'terms',
    name: 'terms',
    meta: {
      show: permissions().terms
    },
    query: {
      action: 'post',
      params: '/player/online/register/operatorDocument'
    }
  },



];
export {
  company,
  downloads,
  rules,
  responsibleGaming
};